import MilkType from "./MilkType";

export default function TbRM({data}) {
    let lr = data.data;
    
    function SiloRow({num}){
      // eslint-disable-next-line
      let lbs = eval("lr.m_rm"+num+"_lbs");
      // eslint-disable-next-line
      let temp = eval("lr.m_rm"+num+"_temp");
      // eslint-disable-next-line
      let pa = eval("lr.m_rm"+num+"_pa") === "Yes";
      // eslint-disable-next-line
      let mTypeId = eval("lr.m_rm"+num+"_type");
      let mType = MilkType.find(x => x.id === 0);
      if (mTypeId === undefined) {
        if (pa) {
          mType = MilkType.find(x => x.id === 6);
        }
      }
      else {
        mType = MilkType.find(x => x.id === mTypeId);
      }
      return (
        <tr>
          <td className={mType.style}>RM {num} {mType.id > 0 && <sup>{mType.code}</sup>}</td>
          <td className={mType.style}>{lbs}</td>
          <td className={mType.style}>{temp}</td>
        </tr>
      )
    }

    return (
      <>
        <div className="card card-table mb-4 rounded-1 shadow-sm">
          <div className="card-header py-2">
            <h4 className="my-0">Raw Milk</h4>
          </div>
          <div className="card-body nopadding">
            <table className="table table-sm my-0 tbl">
              <thead>
                <tr>
                  <th scope="col">Silo</th>
                  <th scope="col">Lbs</th>
                  <th scope="col">Temp</th>
                </tr>
              </thead>
              <tbody>
                <SiloRow num="1" />
                <SiloRow num="2" />
                <SiloRow num="3" />
                <SiloRow num="4" />
                <SiloRow num="5" />
                <SiloRow num="6" />
                <SiloRow num="7" />
                <tr hidden={!lr.cw_cl1_rawmilk}>
                  <td>CL 1</td>
                  <td>{lr.cw_cl1_lbs}</td>
                  <td>{lr.cw_cl1_temp}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    )
}
